import { render, staticRenderFns } from "./RfqPartsTable.vue?vue&type=template&id=b0d3bc62&scoped=true&"
import script from "./RfqPartsTable.vue?vue&type=script&lang=js&"
export * from "./RfqPartsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0d3bc62",
  null
  
)

export default component.exports